export enum RentCoverageTypes {
  CompanyDefault = "My Company's Default",
  Customize = 'Customize Rent Coverage',
}

export enum SecurityDepositTypes {
  CompanyDefault = "My Company's Default",
  CustomizeOrRemove = 'Customize or remove Security Deposit Replacement',
}
